import { createFileRoute, notFound } from '@tanstack/react-router';
import {
    SwedishFiscalReport,
    hasSwedishFiscalIntegrationEnabled,
    swedishFiscalReportSearchSchema,
} from '@mews-commander/modules/src/modules/swedishFiscalReport';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { ErrorHandler } from '@mews-commander/ui';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/SwedishFiscalReport/')({
    validateSearch: (search) => swedishFiscalReportSearchSchema.parse(search),
    component: SwedishFiscalReport,
    loader: async ({ context }) => {
        const res = await context.ensureQueryData('integrations', 'getAll', {});

        if (!hasSwedishFiscalIntegrationEnabled(res)) {
            throw notFound();
        }
    },
    notFoundComponent: () => (
        <ErrorHandler
            errorMessage={<LocalizedText textKey={TextKey.PageNotFoundErrorMessage} />}
            errorTitle={<LocalizedText textKey={TextKey.PageNotFoundTitle} />}
        />
    ),
    staticData: {
        owner: MewsTeam.Expansion,
        type: RouteType.Frontend,
        title: TextKey.SwedishCashReport,
    },
});
